import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { fetchEnrolmentForManagement as fetchEnrolmentDetail } from '../../../../actions/hub/hubEnrolmentManagementActions';
import { isEnrolmentCancelRequested, isGroupSessionCheck } from '../../../../util/helpers';
import { isEnrolmentPausedCheck } from '../../../../util/helpers';
import {
  PATH_HUB_CR_CANCEL_ENROLMENT,
  PATH_HUB_ENROLMENT_CHANGE_SCHEDULE_GROUP,
  PATH_HUB_ENROLMENT_MANAGE_PAUSE,
} from '../../../../util/pagePath';
import useSchoolPeriods from './useSchoolPeriods';

export default function useRedirects({ selectedEnrolment }) {
  const { enrolmentId, enrolmentStatus, enrolmentPausedFrom, enrolmentPausedTo, type } = selectedEnrolment;

  const { currentOrUpcomingHoliday } = useSchoolPeriods();
  const isSummerHoliday = currentOrUpcomingHoliday?.type === 'Summer Holiday';
  const dispatch = useDispatch();
  const history = useHistory();

  /* CRE-103 Redirect Pause Session/Manage Pause */
  useEffect(() => {
    const isEnrolmentPaused = isEnrolmentPausedCheck({ enrolmentStatus });
    const isGroup = isGroupSessionCheck(type);
    const redirectPath = isGroup
      ? PATH_HUB_ENROLMENT_CHANGE_SCHEDULE_GROUP
      : `${PATH_HUB_ENROLMENT_MANAGE_PAUSE}?token=${enrolmentId}`;

    // do not redirect for summer pause, #TODO refactor manage pause in the future
    if (isEnrolmentPaused && !isSummerHoliday) {
      dispatch(
        fetchEnrolmentDetail({
          enrolmentId,
          callback: () => {
            history.replace(redirectPath);
          },
        })
      );
      return undefined;
    } else if (isEnrolmentCancelRequested({ enrolmentStatus })) {
      history.push(`${PATH_HUB_CR_CANCEL_ENROLMENT}?view=form&token=${enrolmentId}`);
    }

    return undefined;
    // eslint-disable-next-line
  }, [enrolmentStatus, enrolmentPausedFrom, enrolmentPausedTo, type, enrolmentId]);
}
